import React, { Component } from 'react';
import { Row, Col, Modal, Form, Input, Icon } from 'antd';

class PasswordInput extends Component {
    state = { type: 'password' }
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.setForm = this.setForm.bind(this);
    }

    toggle() {
        const { type } = this.state;
        if(type === 'password') this.setState({...this.state, type: 'text' });
        else if(type === 'text') this.setState({...this.state, type: 'password' });
    }

    setForm(prev) {
        const
        { field, updateForms } = this.props,
        cState = this.props.state,
        pState = prev.state;

        if(pState[field] !== cState[field]) {
            const
            p1 = cState['newPassword1'],
            p2 = cState['newPassword2'];

            if(p1 !== p2) updateForms([ field ], {
                validateStatus: 'warning',
                help: 'Password does not match.'
            });
            else if(p1 === p2) updateForms([ 'newPassword1', 'newPassword2' ], {
                validateStatus: 'success',
                help: ''
            });
        }
    }

    componentDidUpdate(prev) {
        this.setForm(prev);
    }

    render() {
        const { field, state, services, forms } = this.props;
        let placeholder = '';

        switch(field) {
            case 'oldPassword': placeholder = 'Old password'; break;
            case 'newPassword1': placeholder = 'New password'; break;
            case 'newPassword2': placeholder = 'Re-type new password'; break;
        }

        return (
            <Row type='flex' justify='space-around' align='middle'>
                <Col span={12}>
                    <Form.Item {...forms[field]}>
                        <Input
                            placeholder={placeholder}
                            id={`password-update-field-${field}`}
                            type={this.state.type}
                            prefix={<Icon type='lock' style={{ color: 'rgba(0,0,0,.75)' }} />}
                            suffix={state[field].length <= 0 ? null : (
                                <a href='#' onMouseOver={this.toggle} onMouseOut={this.toggle}>
                                    <Icon
                                        type='eye-o'
                                        style={{ color: 'rgba(0,0,0,.75)' }}
                                    />
                                </a>
                            )}
                            value={state[field]}
                            onChange={(e) => services.updatePassword(field, e.target.value)}
                        />
                    </Form.Item>
                </Col>
            </Row>
        );
    }
}

export default class Update extends Component {
    state = {
        forms: {
            oldPassword: {
                validateStatus: '',
                help: ''
            },
            newPassword1: {
                validateStatus: '',
                help: ''
            },
            newPassword2: {
                validateStatus: '',
                help: ''
            }
        }
    }

    constructor(props) { super(props); }

    updateForms(fields, newState) {
        let updatedState = {...this.state.forms};
        if(fields != null) {
            fields.forEach(f => updatedState[f] = newState);
            this.setState({...this.state, forms: {...updatedState}});
        }
    }

    render() {
        const { state, services, controls, modal } = this.props;
        return (
            <div>
                <Modal
                    id={`password-update-modal`}
                    title={(
                        <div>
                            <span>
                                {'Update Password'}
                            </span>
                        </div>
                    )}
                    visible={state.show}
                    mask={false}
                    onCancel={() => {
                        controls.handleDisplay();
                        services.togglePasswordUpdateView();
                    }}
                >
                    {[
                        <PasswordInput field='oldPassword' key='0' />,
                        <PasswordInput field='newPassword1' key='1' />,
                        <PasswordInput field='newPassword2' key='2' />
                    ].map(c => React.cloneElement(c, {...this.props,
                        forms: {...this.state.forms},
                        updateForms: (fields, newState) => this.updateForms(fields, newState)
                    }))}
                </Modal>
            </div>
        );
    }
}
